export default __webpack_public_path__ + "static/media/back-soft-partner.7f8fe6cf.svg";